import firebase from 'firebase'
import '@firebase/storage'
require('firebase/firestore')

const config = {
  apiKey: 'AIzaSyD0hysA0Erkh2UuvRZ5joZZTgrvqNiZ5t8',
  authDomain: 'candl3d-76.firebaseapp.com',
  databaseURL: 'https://candl3d-76.firebaseio.com',
  projectId: 'candl3d-76',
  storageBucket: 'candl3d-76.appspot.com',
  messagingSenderId: '1025357170458'
}

export const app = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app()
export const auth = firebase.auth()
export const database = firebase.database()
export const storage = firebase.storage()
export const firestore = firebase.firestore()

export default {
  firebase: app,
  database,
  storage,
  auth,
  firestore
}



// WEBPACK FOOTER //
// ./src/firebase.js